module.exports = __webpack_public_path__ + "img/ic_bed.157a0530.svg";